import * as tslib_1 from "tslib";
import { OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from "rxjs/index";
import { FormBuilder, Validators } from "@angular/forms";
import { CsToastBoxService } from "@app/services";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewVehicleService } from "@app/features/fleet-management/add-vehicle/services/view-vehicle-service";
import { JobViewService } from "@app/features/customers/customer/jobs-view/service/job-view-service";
import { GetSelect2FileTagsOptions } from "@app/utils";
import { TABLETYPES } from "@app/config";
import { HttpClient } from "@angular/common/http";
import { GetJobApiUrl } from "@app/utils/get-job-api-url";
import { AuthService } from "@app/core";
import { PropertyViewService } from "@app/features/customers/customer/property-view/service/property-view.service";
var FileEditComponent = /** @class */ (function () {
    function FileEditComponent(formBuilder, viewVehicleService, bsModalRef, toastBoxService, sanitizer, jobViewService, http, authService, propertyViewService) {
        this.formBuilder = formBuilder;
        this.viewVehicleService = viewVehicleService;
        this.bsModalRef = bsModalRef;
        this.toastBoxService = toastBoxService;
        this.sanitizer = sanitizer;
        this.jobViewService = jobViewService;
        this.http = http;
        this.authService = authService;
        this.propertyViewService = propertyViewService;
        this.action = 'save';
        this.fileExtension = '';
        this.imageView = false;
        this.screen = '';
        this.showFile = true;
        this.showTagDropDown = false;
        this.selectedTags = [];
        this.isTagUpdated = false;
        this.shareOnMobile = false;
        this.showShareOnMobile = false;
    }
    FileEditComponent.prototype.ngOnInit = function () {
        this.shareOnMobile = this.data['imageData'].shareOnMobile;
        this.onClose = new Subject();
        this.imageView = false;
        var _a = this.getFileNameParts(this.data['imageData'].name, this.data['imageData'].filetype), baseName = _a.baseName, extension = _a.extension;
        this.fileNames = this.data['imageData'].name;
        this.fileExtension = extension;
        this.screen = (this.data['screen']) ? this.data['screen'] : '';
        this.showFile = (this.data['showFile'] !== undefined && this.data['showFile'] !== null)
            ? this.data['showFile']
            : true;
        this.showTagDropDown = (this.data['showTagDropDown'] !== undefined && this.data['showTagDropDown'] !== null)
            ? this.data['showTagDropDown']
            : false;
        if (this.showTagDropDown) {
            this.tagsSelect2Config = GetSelect2FileTagsOptions();
        }
        if (this.data['modalType'] == 'edit') {
            this.buildAttachedFilesForm(this.data); //form initalizes
            if (this.data['imageData'].filetype == 'PDF' || this.data['imageData'].filetype == 'pdf') {
                this.fileLocation = this.sanitizer.bypassSecurityTrustResourceUrl(this.data['imageData'].location);
            }
            else {
                this.fileLocation = this.data['imageData'].location; //get image path and store imgloation variable
            }
        }
        else {
            if (this.data['imageData'].filetype == 'PDF' || this.data['imageData'].filetype == 'pdf') {
                this.fileLocation = this.sanitizer.bypassSecurityTrustResourceUrl(this.data['imageData'].location);
            }
            else {
                this.fileLocation = this.data['imageData'].location; //get image path and store imgloation variable
                this.imageView = true;
            }
        }
    };
    FileEditComponent.prototype.ngAfterViewInit = function () {
        var setUpfileTagsReadAccess = this.authService.permitted(['SetupFileTags.readaccess']) === true;
        if (this.showTagDropDown && setUpfileTagsReadAccess) {
            if (this.data['imageData'].hasOwnProperty('selectedFileTag') && this.data['imageData'].selectedFileTag.length) {
                this.tagsSelect2Config['data'] = this.data['imageData'].selectedFileTag;
                $(this.select2FileTags.nativeElement).select2('data', this.data['imageData'].selectedFileTag);
            }
        }
    };
    // build attached files form
    FileEditComponent.prototype.buildAttachedFilesForm = function (data) {
        var baseName = this.getFileNameParts(data['imageData'].name, data['imageData'].filetype).baseName;
        this.attachedFileEditForm = this.formBuilder.group({
            'id': [data['imageData'].id],
            'fileName': [baseName, [Validators.required, this.noWhitespaceValidator]],
            'shareOnMobile': [data['imageData'].shareOnMobile || false],
        });
    };
    FileEditComponent.prototype.save = function () {
        var _this = this;
        if (!this.attachedFileEditForm || this.attachedFileEditForm.invalid) {
            this.attachedFileEditForm.get('fileName').markAsTouched();
            return;
        }
        this.action = 'saving';
        var id = this.attachedFileEditForm.value.id;
        var updatedFileName = this.getUpdatedFileName(this.attachedFileEditForm.value.fileName);
        if (!updatedFileName || updatedFileName === this.fileExtension) {
            this.attachedFileEditForm.get('fileName').setErrors({ whitespace: true });
            this.attachedFileEditForm.get('fileName').markAsTouched();
            this.action = 'save';
            return;
        }
        var data = {
            fileName: updatedFileName,
            id: id,
            shareOnMobile: this.attachedFileEditForm.value.shareOnMobile
        };
        var renameData = {
            fileId: id,
            fileType: this.data['imageData'].filetype,
            name: (this.attachedFileEditForm.value.fileName || '').trim(),
        };
        var updateFile$ = this.screen === 'jobFiles'
            ? this.jobViewService.updateFile(id, data)
            : this.propertyViewService.renameFiles(renameData);
        // Call main save API
        updateFile$.subscribe({
            next: function () {
                _this.fileNames = updatedFileName;
                // After file save success, check and update tags
                if (_this.isTagUpdated) {
                    var tagPayload = {
                        tags: _this.selectedTags,
                        tableType: TABLETYPES.ATTACHED_FILES,
                        fileId: id
                    };
                    _this.http.post(GetJobApiUrl('e5ec7051/addEditFileTags'), tagPayload).subscribe({
                        next: function () {
                            _this.onClose.next(true);
                            _this.bsModalRef.hide();
                            _this.action = '';
                        },
                        error: function (err) {
                            console.error('Error saving tags:', err);
                            _this.action = '';
                        }
                    });
                }
                else {
                    // If no tag update needed, just close
                    _this.onClose.next(true);
                    _this.bsModalRef.hide();
                    _this.action = '';
                }
            },
            error: function (error) {
                console.error('Error saving file:', error);
                _this.action = '';
            }
        });
    };
    FileEditComponent.prototype.attachFileDownload = function (imageSrc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var image, imageBlog, imageURL, link;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(imageSrc)];
                    case 1:
                        image = _a.sent();
                        return [4 /*yield*/, image.blob()];
                    case 2:
                        imageBlog = _a.sent();
                        imageURL = URL.createObjectURL(imageBlog);
                        link = document.createElement('a');
                        link.href = imageURL;
                        link.download = this.fileNames;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    FileEditComponent.prototype.onCloseModal = function () {
        var _this = this;
        setTimeout(function () {
            _this.bsModalRef.hide();
        }, 100);
    };
    FileEditComponent.prototype.ngOnDestroy = function () {
        $('body').addClass("modal-open");
    };
    FileEditComponent.prototype.selectedTag = function (tag) {
        this.selectedTags = tag;
        this.isTagUpdated = true;
    };
    FileEditComponent.prototype.getFileNameParts = function (fileName, fileType) {
        var normalizedExtension = this.normalizeExtension(fileType);
        if (!fileName) {
            return { baseName: '', extension: normalizedExtension };
        }
        var lastDotIndex = fileName.lastIndexOf('.');
        if (lastDotIndex <= 0) {
            return { baseName: fileName, extension: normalizedExtension };
        }
        return {
            baseName: fileName.substring(0, lastDotIndex),
            extension: fileName.substring(lastDotIndex),
        };
    };
    FileEditComponent.prototype.normalizeExtension = function (fileType) {
        var trimmedFileType = (fileType || '').trim();
        if (!trimmedFileType) {
            return '';
        }
        return trimmedFileType.startsWith('.')
            ? trimmedFileType
            : "." + trimmedFileType;
    };
    FileEditComponent.prototype.getUpdatedFileName = function (fileName) {
        var trimmedFileName = (fileName || '').trim();
        if (!trimmedFileName) {
            return this.fileExtension;
        }
        if (!this.fileExtension) {
            return trimmedFileName;
        }
        return trimmedFileName.endsWith(this.fileExtension)
            ? trimmedFileName
            : "" + trimmedFileName + this.fileExtension;
    };
    FileEditComponent.prototype.noWhitespaceValidator = function (control) {
        var value = (control.value || '').trim();
        return value ? null : { whitespace: true };
    };
    return FileEditComponent;
}());
export { FileEditComponent };
